export const locations = {
  header: 'Manage Locations',
  createNew: 'Create a new location',
  filters: {
    searchPlaceholder: 'Location name...'
  },
  table: {
    nameHeader: 'NAME',
    addressHeader: 'ADDRESS',
    activeJobsHeader: 'ACTIVE JOBS',
  },
  noResults: {
    title: 'You do not have any existing locations',
    description: 'Every job must have a location assigned to it. Once you create a location, you can easily assign it to any job.',
  },
  deleteTooltip: 'This location is being used by one or more active jobs',
  deleteConfirmation: {
    title: 'Are you sure you want to delete this location?',
    description: 'This action cannot be undone.',
    confirm: 'Yes, delete location'
  },
  deleteSuccess: '%venueName% has been deleted',
  editConfirmation: {
    title: 'This location is currently being used',
    descriptionHeader: 'You have active workdays using this location',
    descriptionBody: 'Since this location is active, not all fields will be editable. Wonoloers will be informed of any changes.',
    confirm: 'Continue with editing'
  },
  emptyResults: {
    description: 'Try using a different keyword for your search.'
  }
};
